module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-7-e32c2063bf8f3487b35a0d3ba9b493a9.webp";